// https://github.com/iamyoki/transition-hook

import { useState, useEffect, useRef } from 'react'

const setAnimationFrameTimeout = (callback, timeout = 0) => {
  const start = performance.now()
  let cancelId = 0

  const call = () => {
    cancelId = requestAnimationFrame(now => {
      if (now - start > timeout) {
        callback()
      } else {
        call()
      }
    })
  }

  call()
  return cancelId
}

const clearAnimationFrameTimeout = cancelId => {
  if (cancelId) {
    cancelAnimationFrame(cancelId)
  }
}

const useTransition = (state, timeout, initialStage = 'leave') => {
  // the stage of transition - 'from' | 'enter' | 'leave'
  const [stage, setStage] = useState(initialStage)
  const [shouldMount, setShouldMount] = useState(state)
  const timer = useRef(0)

  useEffect(() => {
    if ((state && stage === 'from') || (!state && stage === 'leave')) {
      return
    }

    clearAnimationFrameTimeout(timer.current)
    // when true - trans from to enter
    if (state) {
      setStage('from')
      setShouldMount(true)
      setAnimationFrameTimeout(() => {
        setStage('enter')
      })
    }
    // when false - trans enter to leave, unmount after timeout
    else {
      setStage('leave')
      timer.current = setAnimationFrameTimeout(() => {
        setShouldMount(false)
      }, timeout)
    }

    return () => {
      clearAnimationFrameTimeout(timer.current)
    }
    // Disable line to prevent rerenders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, timeout])

  return {
    stage,
    shouldMount,
  }
}

export default useTransition
